// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_fragment_developments(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
    "ChapterDefaultNotificationSetting",
    "CustomDevelopmentNotificationPreference"
  ]);
}

let fragmentConverter = {"__root":{"developments_CustomDevelopmentNotificationPreference_areaGroup":{"f":""},"developments":{"u":"fragment_developments"},"":{"f":""}}};

let fragmentConverterMap = {
  fragment_developments: unwrap_fragment_developments
};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, fragmentConverterMap, undefined);
}

let Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: fragmentConverterMap,
  convertFragment: convertFragment
};

let Utils = {};

let node = ((function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NotificationSettingsNewDevelopments_notificationSetting",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NotificationSettingsPreferenceEditDialogAreaGroups_settings"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "developments",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "userHasInactiveCustomPreference",
                "storageKey": null
              },
              "action": "THROW"
            }
          ],
          "type": "ChapterDefaultNotificationSetting",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "areaGroup",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "NotificationSettingsComponents_group"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "NotificationSettingsNewDevelopments_areaGroup"
                }
              ],
              "storageKey": null
            }
          ],
          "type": "CustomDevelopmentNotificationPreference",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "UserNotificationSettingsV5",
  "abstractKey": null
};
})());

let wrap_fragment_developments = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_fragment_developments = unwrap_fragment_developments;
exports.wrap_fragment_developments = wrap_fragment_developments;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
